


































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { TsEqGridChartLabels, TsEqGridChartLegends } from '@/interfaces'

@Component({
  name: 'EqGridChart'
})
export default class EqGridChart extends Vue {
  @Prop({ required: true })
  performanceReviewScore!: number

  @Prop({ required: true })
  leadershipSurveyScore!: number

  @Prop({ required: true })
  id!: string

  @Prop({ required: true })
  gridLabels!: TsEqGridChartLabels | []

  @Prop()
  legends!: TsEqGridChartLegends[] | []

  chartWidth = 0

  @Watch('performanceReviewScore', { immediate: true })
  onPerformanceReviewScoreChanged () {
    this.tsEqGridChart()
  }

  @Watch('leadershipSurveyScore', { immediate: true })
  onLeadershipSurveyScoreChanged () {
    this.tsEqGridChart()
  }
  handleResize () {
    this.tsEqGridChart()
  }

  mounted () {
    this.tsEqGridChart()
    window.addEventListener('resize', this.handleResize)
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }

  markerStyles (scoreX: number, scoreY: number):string {
    if (scoreX < 70) {
      scoreX = 70
    }
    if (scoreY < 70) {
      scoreY = 70
    }
    let markerBottom = (scoreY - 70) * (100 / 30)
    let markerLeft = (scoreX - 70) * (100 / 30)
    return `bottom:${markerBottom}%;left:${markerLeft}%;`
  }

  tsEqGridChart (): void {
    let chartElement = document.querySelector(`#${this.id}`)
    this.chartWidth = chartElement ? chartElement.clientWidth : 0
  }
}
